import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.67105 1.59007L3.66692 1.58594L2.25269 3.00013L4.39573 5.14323C3.57972 5.59808 2.79318 6.12533 2.0455 6.72498L1.26636 7.34987L12.6671 21.6008L16.3052 17.053L21.6665 22.4144L23.0764 21.0045L3.66675 1.59437L3.67105 1.59007Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.8156 13.9151L24.0678 7.34974L23.2887 6.72485C19.0212 3.30228 13.4881 2.23837 8.43366 3.53293L18.8156 13.9151Z"}}]};

const WifiOff1Filled = Vue.extend<IconProps>({
  name: 'WifiOff1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wifi-off-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WifiOff1Filled;
